export enum ScheduleType {
    Door = 'door',
    Window = 'window',
    RoomFinish = 'room_finish',
    RoomName = 'room_name',
    PlumbingFixture = 'plumbing_fixture',
    SheetIndex = 'sheet_index',
    MechanicalFixture = 'mechanical_fixture',
    Wall = 'wall',
    LightingFixture = 'lighting_fixture',
  }

export const LabelToText = {
    [ScheduleType.SheetIndex]: 'Sheet Index',
    [ScheduleType.Door]: 'Door',
    [ScheduleType.Window]: 'Window',
    [ScheduleType.RoomFinish]: 'Room Finish',
    [ScheduleType.RoomName]: 'Room Name',
    [ScheduleType.PlumbingFixture]: 'Plumbing Fixture',
    [ScheduleType.MechanicalFixture]: 'Mechanical Fixture',
    [ScheduleType.Wall]: 'Wall',
    [ScheduleType.LightingFixture]: 'Lighting Fixture',
  }

export function scheduleTypeToString(type: ScheduleType): string {
  return LabelToText[type] + ' Schedule'
}

export function stringToScheduleType(scheduleType: string): ScheduleType {
  const trimmed = scheduleType.replace(' Schedule', '');
  for (const [key, value] of Object.entries(LabelToText)) {
    if (value === trimmed) {
      return key as ScheduleType;
    }
  }
  throw new Error(`Unknown schedule type: ${scheduleType}`);
}